import { useState } from 'react';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {

	const { widgetToken, widgetType } = attributes;
	const [ isInEditMode, setIsInEditMode ] = useState(false);
	// keep state values for the form inputs - so the user can cancel without impacting the stored block attributes
	const [ userInputToken, setUserInputToken ] = useState(widgetToken);
	const [ userInputType, setUserInputType ] = useState(widgetType);

	function setWidgetToken(token) {
		setAttributes({ widgetToken: token });
	}

	function setWidgetType(type) {
		setAttributes({ widgetType: type });
	}

	function saveUpdateForm(ev) {
		ev.stopPropagation();
		ev.preventDefault();

		setWidgetToken(userInputToken);
		setWidgetType(userInputType);
		setIsInEditMode(false);
	}

	function cancelUpdateForm() {
		setWidgetToken(widgetToken);
		setWidgetType(widgetType);
		setIsInEditMode(false);
	}

	if(isInEditMode) {
		return (
			<form {...useBlockProps()}>
				<label for='#ug_widget_token_input'>Widget Token</label>
				<input id='ug_widget_token_input' type='text' placeholder='Token' value={userInputToken} onChange={(e) => setUserInputToken(e.currentTarget.value)} />
				<label for='#ug_widget_type_select'>Widget Type</label>
				<select id='ug_widget_type_select' onChange={(e) => setUserInputType(e.currentTarget.value)}>
					<option value='Full Page' selected={userInputType === 'Full Page'}>Full Page</option>
					<option value='Ad' selected={userInputType === 'Ad'}>Ad Size</option>
				</select>
				<button onClick={cancelUpdateForm}>
					Cancel
				</button>
				<button type='submit' onClick={saveUpdateForm}>
					Save
				</button>
			</form>
		);
	}

	if(widgetToken && widgetType) {
		return (
			<div {...useBlockProps()}>
				<p className='example-class-ug'>your widget token is: { widgetToken }</p>
				<p>your widget type is: { widgetType }</p>
				<button onClick={() => setIsInEditMode(true)}>update</button>
			</div>
		);
	}

	return (
		<div {...useBlockProps()}>
			<button onClick={() => setIsInEditMode(true)}>Setup widget or something</button>
		</div>

	);
}
